import { render, staticRenderFns } from "./LangModal.vue?vue&type=template&id=34429b6c&scoped=true&"
import script from "./LangModal.vue?vue&type=script&lang=js&"
export * from "./LangModal.vue?vue&type=script&lang=js&"
import style0 from "./LangModal.vue?vue&type=style&index=0&id=34429b6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34429b6c",
  null
  
)

export default component.exports